import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { useGlobalConfigContext } from '../../global-config'
import { useDirectContactFormTelephoneTranslations } from '../hooks/useDirectContactFormTelephoneTranslations'

export const DirectContactTelephoneAvailableBox: FC = () => {
  const { tenant } = useGlobalConfigContext()
  const { getWeekdaysOrEntireWeekLabel, shouldRenderSaturdaysLine } =
    useDirectContactFormTelephoneTranslations(false, tenant)

  return (
    <div className="mb-6 flex w-full flex-col gap-2 rounded-m border border-dark-primary-min p-4 text-m">
      <div className="flex justify-between">
        <p>{getWeekdaysOrEntireWeekLabel()}</p>
        <p className="font-medium">
          <FormattedMessage id="contact.directContactSection.customerSupportDialog.availableTimeframe" />
        </p>
      </div>
      {shouldRenderSaturdaysLine() && (
        <div className="flex justify-between">
          <p>
            <FormattedMessage id="contact.directContactSection.customerSupportDialog.saturday.label" />
          </p>
          <p className="font-medium">
            <FormattedMessage id="contact.directContactSection.customerSupportDialog.availableTimeframe.saturday" />
          </p>
        </div>
      )}
    </div>
  )
}
